import {ICategory} from '../interfaces/ICategory';
import {INotificationsSetting} from '../interfaces/INotificationsSetting';

export const NotificationsSettingsDefault: INotificationsSetting[] = [
    {
        label: 'Blog',
        info: 'Ricevi una notifica ogni nuovo Post della sezione selezionata.',
        children: [
            {
                id: 100,
                active: false,
                title: 'Tutte',
                topic: null,
            },
            {
                id: 0,
                active: true,
                title: 'Comunicazioni',
                topic: 'comunicazioni',
            },

            {
                id: 1,
                active: false,
                title: 'Prodotti consigliati',
                topic: 'prodotti-consigliati',
            }
            /*
            {
                id: 1,
                active: false,
                title: 'Articoli',
                topic: 'articoli',
            },
            {
                id: 2,
                active: false,
                title: 'Guide',
                topic: 'guide',
            },
             */
        ]
    },
    {
        label: 'Super Affari',
        info: 'Ricevi una notifica per ogni nuova Offerta di tipo Super Affare delle categorie selezionate.',
        children: [
            {
                id: 100,
                active: false,
                title: 'Tutte',
                topic: null,
            },
            {
                id: 0,
                active: false,
                title: 'Abbigliamento',
                topic: 'affari-abbigliamento',
            },
            {
                id: 1,
                active: false,
                title: 'Bellezza e Cura della Persona',
                topic: 'affari-bellezza-cura',
            },
            {
                id: 2,
                active: false,
                title: 'Casa e Cucina',
                topic: 'affari-casa-cucina',
            },
            {
                id: 3,
                active: false,
                title: 'Cibo e Bevande',
                topic: 'affari-cibo-bevande',
            },
            {
                id: 4,
                active: false,
                title: 'Elettronica e Informatica',
                topic: 'affari-elettronica-informatica',
            },
            {
                id: 5,
                active: false,
                title: 'Fai da te e Giardinaggio',
                topic: 'affari-fai-da-te-giardinaggio',
            },
            {
                id: 6,
                active: false,
                title: 'Gaming',
                topic: 'affari-gaming',
            },
            {
                id: 7,
                active: false,
                title: 'Giochi e Giocattoli',
                topic: 'affari-giochi-giocattoli',
            },
            {
                id: 8,
                active: false,
                title: 'Gioielli e Orologi',
                topic: 'affari-gioielli-orologi',
            },
            {
                id: 9,
                active: false,
                title: 'Prima infanzia',
                topic: 'affari-prima-infanzia',
            },
            {
                id: 10,
                active: false,
                title: 'Prodotti per animali domestici',
                topic: 'affari-prodotti-animali',
            },
            {
                id: 11,
                active: false,
                title: 'Smartphone e Accessori',
                topic: 'affari-smartphone-accessori',
            },
            {
                id: 12,
                active: false,
                title: 'Sport, Fitness e Accessori',
                topic: 'affari-sport-fitness-accessori',
            },
            {
                id: 13,
                active: false,
                title: 'Altro',
                topic: 'affari-altro',
            }
        ]
    },
    {
        label: 'Minimi Storici',
        info: 'Ricevi una notifica per ogni nuova Offerta di tipo Combo o Minimo Storico delle categorie selezionate.',
        children: [
            {
                id: 100,
                active: false,
                title: 'Tutte',
                topic: null,
            },
            {
                id: 0,
                active: false,
                title: 'Abbigliamento',
                topic: 'minimi-abbigliamento',
            },
            {
                id: 1,
                active: false,
                title: 'Bellezza e Cura della Persona',
                topic: 'minimi-bellezza-cura',
            },
            {
                id: 2,
                active: false,
                title: 'Casa e Cucina',
                topic: 'minimi-casa-cucina',
            },
            {
                id: 3,
                active: false,
                title: 'Cibo e Bevande',
                topic: 'minimi-cibo-bevande',
            },
            {
                id: 4,
                active: false,
                title: 'Elettronica e Informatica',
                topic: 'minimi-elettronica-informatica',
            },
            {
                id: 5,
                active: false,
                title: 'Fai da te e Giardinaggio',
                topic: 'minimi-fai-da-te-giardinaggio',
            },
            {
                id: 6,
                active: false,
                title: 'Gaming',
                topic: 'minimi-gaming',
            },
            {
                id: 7,
                active: false,
                title: 'Giochi e Giocattoli',
                topic: 'minimi-giochi-giocattoli',
            },
            {
                id: 8,
                active: false,
                title: 'Gioielli e Orologi',
                topic: 'minimi-gioielli-orologi',
            },
            {
                id: 9,
                active: false,
                title: 'Prima infanzia',
                topic: 'minimi-prima-infanzia',
            },
            {
                id: 10,
                active: false,
                title: 'Prodotti per animali domestici',
                topic: 'minimi-prodotti-animali',
            },
            {
                id: 11,
                active: false,
                title: 'Smartphone e Accessori',
                topic: 'minimi-smartphone-accessori',
            },
            {
                id: 12,
                active: false,
                title: 'Sport, Fitness e Accessori',
                topic: 'minimi-sport-fitness-accessori',
            },
            {
                id: 13,
                active: false,
                title: 'Altro',
                topic: 'minimi-altro',
            }
        ]
    },
    {
        label: 'Nuove Offerte',
        info: 'Ricevi una notifica ogni qualvolta verranno inserite 30-60 nuove offerte e non più di 4 volte al giorno.',
        children: [
            {
                id: 0,
                active: true,
                title: 'Nuove Offerte',
                topic: 'nuove-offerte',
            }
        ]

    }
];

export const CategoryListDefault: ICategory[] = [
    {
        id: 0,
        selected: false,
        title: 'ABBIGLIAMENTO, SCARPE E BORSE',
        image: 'ABBIGLIAMENTO'
    }, {
        id: 1,
        selected: false,
        title: 'BELLEZZA E CURA DELLA PERSONA',
        image: 'BELLEZZAECURA'
    }, {
        id: 2,
        selected: false,
        title: 'CASA E CUCINA',
        image: 'CASAECUCINA'
    }, {
        id: 3,
        selected: false,
        title: 'CIBO E BEVANDE',
        image: 'CIBOEBEVANDE'
    }, {
        id: 4,
        selected: false,
        title: 'ELETTRONICA E INFORMATICA',
        image: 'ELETTRONICA'
    }, {
        id: 5,
        selected: false,
        title: 'FAI DA TE E GIARDINAGGIO',
        image: 'FAIDATE'
    }, {
        id: 6,
        selected: false,
        title: 'GAMING',
        image: 'GAMING'
    }, {
        id: 7,
        selected: false,
        title: 'GIOCHI E GIOCATTOLI',
        image: 'GIOCATTOLI'
    }, {
        id: 8,
        selected: false,
        title: 'GIOIELLI E OROLOGI',
        image: 'GIOIELLIEOROLOGI'
    }, {
        id: 9,
        selected: false,
        title: 'PRIMA INFANZIA',
        image: 'PRIMAINFANZIA'
    }, {
        id: 10,
        selected: false,
        title: 'PRODOTTI PER ANIMALI DOMESTICI',
        image: 'PRODOTTIANIMALIDOMESTICI'
    }, {
        id: 11,
        selected: false,
        title: 'SMARTPHONE E ACCESSORI',
        image: 'SMARTPHONEEACCESSORI'
    }, {
        id: 12,
        selected: false,
        title: 'SPORT, FITNESS E ACCESSORI',
        image: 'SPORTFITNESS'
    }, {
        id: 13,
        selected: false,
        title: 'ALTRO...',
        image: 'ALTRO'
    }
];

export const FilterListDefault = [
    {
        id: 0,
        selected: false,
        type: 0
    }, {
        id: 1,
        selected: false,
        type: 0
    }, {
        id: 2,
        selected: false,
        type: 0
    }, {
        id: 3,
        selected: false,
        type: 0
    }, {
        id: 4,
        selected: false,
        type: 1
    }, {
        id: 5,
        selected: false,
        type: 1
    }, {
        id: 6,
        selected: false,
        type: 2
    }, {
        id: 7,
        selected: false,
        type: 2
    }, {
        id: 8,
        selected: false,
        type: 2
    }, {
        id: 9,
        selected: false,
        type: 3
    }, {
        id: 10,
        selected: false,
        type: 3
    }, {
        id: 11,
        selected: false,
        type: 3
    }, {
        id: 12,
        selected: false,
        type: 3
    }, {
        id: 13,
        selected: false,
        type: 0
    }, {
        id: 14,
        selected: false,
        type: 4
    }, {
        id: 15,
        selected: false,
        type: 4
    }, {
        id: 16,
        selected: false,
        type: 4
    }, {
        id: 17,
        selected: false,
        type: 4
    }, {
        id: 18,
        selected: false,
        type: 1
    }, {
        id: 19,
        selected: false,
        type: 1
    }, {
        id: 20,
        selected: false,
        type: 5
    }, {
        id: 21,
        selected: false,
        type: 2
    }
];

export const OrderListDefault = [
    {
        id: 0,
        selected: false,
        type: 0,
        ordinaPer: 'Per popolarità'
    },
    {
        id: 1,
        selected: false,
        type: 0,
        ordinaPer: 'Per sconto crescente'
    },
    {
        id: 2,
        selected: false,
        type: 0,
        ordinaPer: 'Per sconto decrescente'
    },
    {
        id: 3,
        selected: false,
        type: 0,
        ordinaPer: 'Per prezzo crescente'
    },
    {
        id: 4,
        selected: false,
        type: 0,
        ordinaPer: 'Per prezzo decrescente'
    }
];
